import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { useAppTheme } from "@hooks/useAppTheme";
import { Box } from "@memorang/ui";
import { useTranslation } from "react-i18next";
import { Button, Text } from "react-native-paper";

const NoInternetAccess = ({
	loading,
	onRetry,
}: {
	loading: boolean;
	onRetry: () => void;
}) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box
			alignItems="center"
			justifyContent="center"
			padding={16}
			gap={8}
			flex={1}
			position="absolute"
			top={0}
			left={0}
			right={0}
			bottom={0}
			zIndex={99999}
			backgroundColor={theme.colors.background}
		>
			<MaterialCommunityIcons
				color={theme.colors.onSurfaceVariant}
				size={48}
				name="wifi-strength-off-outline"
			/>
			<Text variant="titleLarge" style={{ marginTop: 24 }}>
				{t("noInternetAccess.title")}
			</Text>
			<Text
				variant="bodyLarge"
				style={{ textAlign: "center", marginBottom: 24 }}
			>
				{t("noInternetAccess.subtitle")}
			</Text>
			<Button
				mode="contained"
				onPress={onRetry}
				loading={loading}
				disabled={loading}
			>
				{t("noInternetAccess.retry")}
			</Button>
		</Box>
	);
};

export default NoInternetAccess;
